var React = require('react');

function LongArrowAltLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M436.13 296H134.19v-80h301.94a12 12 0 0 1 12 12v56a12 12 0 0 1-12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M93.19 359.07L7.13 273a24 24 0 0 1 0-33.94L93.22 153c15.12-15.12 41-4.41 41 17v172.09c-.03 21.36-25.88 32.07-41.03 16.98z","className":"fa-primary","key":2})]);
}

LongArrowAltLeft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = LongArrowAltLeft;

LongArrowAltLeft.default = LongArrowAltLeft;
